import { FC } from "react";

type ArrowDirection = "up-right" | "up-left" | "down-right" | "down-left";

interface ArrowDiagonalSvgProps {
  size?: number;
  direction?: ArrowDirection;
}

const rotationMap: Record<ArrowDirection, number> = {
  "up-right": 0,
  "down-right": 90,
  "down-left": 180,
  "up-left": 270,
};

const ArrowDiagonalSvg: FC<ArrowDiagonalSvgProps> = ({ size = 16, direction = "up-left" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: `rotate(${rotationMap[direction]}deg)`,
      }}
    >
      <path
        d="M5.67123 5.17131L11.3281 10.8282"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.67338 9.41647V5.17383H9.91602"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowDiagonalSvg;
